module.exports = __webpack_public_path__ + "media/images/expand-55e74d519adcfda231ee0f714191f68c.png";